

export const Tools = {

    /**
     * @param text
     * @return {*}
     */
    MatchText: (text) => {
        return text.match(/(?=.*[\w\_\s]{5,})/);
    },

    /**
     * @param json
     * @return {any}
     */
    Clone: (json) => {
        return JSON.parse(JSON.stringify(json));
    },

    /**
     * @param json
     * @return {string}
     * @constructor
     */
    JsonToString: (json) => {
        return JSON.stringify(json);
    },

    /**
     * @param string
     * @return {any}
     * @constructor
     */
    StringToJson: (string) => {
        return JSON.parse(string);
    },

    /**
     * Check or uncheck the checkbox inputs against an object of field names and their values
     * @param inputRefs JSON {"input1Ref":"v1",..."inputNRef":"vN"}
     * @param inputsNameSource JSON {"inputName1":"v1",..."inputNameN":"vN"}
     */
    UpdateCheckboxInputRef: (inputRefs, inputsNameSource) => {
        Object.keys(inputRefs).forEach((key) => {
            if(inputsNameSource.hasOwnProperty(key) && typeof inputsNameSource[key] === "boolean"
                && inputRefs[key] && inputRefs[key].current && inputRefs[key].current.type === "checkbox"){
                inputRefs[key].current.checked = inputsNameSource[key];
            }
        });
    },

    /**
     * Check if variable is empty
     * @param object
     * @return {boolean}
     * @constructor
     */
    IsEmpty(object) {
        if(!object)
            return true;
        return (Array.isArray(object) && object.length <= 0) || Object.keys(object).length <= 0;
    },

    /**
     *
     * @param key
     * @param value
     * @param list
     * @return {null|*}
     * @constructor
     */
    GetItem(key, value, list) {
        if(list){
            return list.find((item) => {
                 return item[key] === value;
            });
        }
        return null;
    },

    /**
     *
     * @param key
     * @param value
     * @param list
     * @return {null|*}
     * @constructor
     */
    GetItemIndex(key, value, list) {
        if(list){
            return list.findIndex((item) => {
                 return item[key] === value;
            });
        }
        return null;
    },

    /**
     *
     * @param startDate {string}
     * @param endDate {string}
     * @param strict {boolean}
     * @return {boolean}
     * @constructor
     */
    IsCurrentDateBetween(startDate, endDate, strict = true) {
        return Tools.IsDateBetween((new Date()).getTime(), startDate, endDate);
    },

    DiffDateAsTime(date1, date2, strict = true) {
        return Math.abs((new Date(date1)).getTime() - (new Date(date2)).getTime());
    },

    /**
     *
     * @param currentDateAsTime {number}
     * @param startDate {string}
     * @param endDate {string}
     * @param strict {boolean}
     * @return {boolean}
     * @constructor
     */
    IsDateBetween(currentDateAsTime, startDate, endDate, strict = true) {
        if(strict){
            return (new Date(startDate)).getTime() < currentDateAsTime && currentDateAsTime < (new Date(endDate)).getTime();
        }
        return (new Date(startDate)).getTime() <= currentDateAsTime && currentDateAsTime <= (new Date(endDate)).getTime();
    },

    /**
     *
     * @param date {string}
     * @return {boolean}
     * @constructor
     */
    IsDateExpired(date) {
        return date && (new Date()).getTime() > (new Date(date)).getTime();
    },

    MonthByIndex(index){
        const months = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];
        return months[index - 1] ? months[index - 1] : "-";
    }
};